module.exports = __webpack_public_path__ + "img/enroll-a-portable-gen.1675d7d0.svg";